<template>
  <div class="wt-tool">
    <div class="editor-pane" v-if="!result">
      <div class="pane-header">
        <span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.WordToHtml.upload') }}</span>
        <span class="pane-hint">{{ $t('tool.WordToHtml.uploadHint') }}</span>
      </div>
      <el-upload ref="upload" drag action="#" :auto-upload="false" :on-change="handleFile" :limit="1" accept=".docx,.doc" :file-list="fileList">
        <i class="el-icon-upload" style="font-size:42px;color:#c0c4cc;" />
        <div class="el-upload__text">{{ $t('tool.WordToHtml.dropText') }}<em>{{ $t('tool.WordToHtml.clickUpload') }}</em></div>
      </el-upload>
      <div style="text-align:center;margin-top:12px;" v-if="file">
        <el-button type="primary" size="small" :loading="loading" @click="convert">{{ $t('tool.WordToHtml.btnConvert') }}</el-button>
      </div>
    </div>

    <div class="editor-pane" v-if="result">
      <div class="pane-header">
        <span class="pane-dot output-dot" /><span class="pane-label">{{ $t('tool.WordToHtml.resultLabel') }}</span>
        <span class="pane-hint">{{ $t('tool.WordToHtml.resultHint') }}</span>
      </div>
      <div class="wt-preview" v-html="result" />
      <div style="margin-top:14px;display:flex;gap:8px;">
        <el-button size="small" type="primary" @click="downloadHtml">{{ $t('tool.WordToHtml.download') }}</el-button>
        <el-button size="small" @click="doAction('copy')">{{ $t("common.action.copy") }}</el-button>
        <el-button size="small" @click="reset">{{ $t('tool.WordToHtml.reupload') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { convertWordToHtml } from '@/api/site'
export default {
  name:'WordToHtmlTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({file:null,fileList:[],loading:false,result:''}),
  methods:{
    handleFile(f){if(f.size>50*1024*1024){this.$message.error(this.$t('tool.WordToHtml.maxSize'));return}this.file=f.raw;this.fileList=[f]},
    async convert(){if(!this.file)return;this.loading=true;try{const fd=new FormData();fd.append('file',this.file);const res=await convertWordToHtml(fd);this.result=res.data||''}catch(e){this.$message.error(this.$t("common.status.failed"))};this.loading=false},
    reset(){this.result='';this.file=null;this.fileList=[]},
    downloadHtml(){var blob=new Blob([this.result],{type:'text/html'});var url=URL.createObjectURL(blob);if(/iPhone|iPad|iPod/i.test(navigator.userAgent)){var file=new File([blob],'converted.html',{type:'text/html'});if(navigator.share){navigator.share({files:[file]}).catch(function(){window.open(url,'_blank')})}else{window.open(url,'_blank')}}else{var a=document.createElement('a');a.href=url;a.download='converted.html';document.body.appendChild(a);a.click();document.body.removeChild(a);setTimeout(function(){URL.revokeObjectURL(url)},3000)}},
    doAction(a){if(a==='copy'){navigator.clipboard.writeText(this.result);this.$message.success(this.$t("common.status.copied"))}if(a==='clear')this.reset()}
  }
}
</script>

<style scoped>
.wt-tool { display:flex;flex-direction:column;gap:16px; }
.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; min-width:0; overflow:hidden; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:12px; flex-wrap:wrap; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.output-dot { background:#43e97b;box-shadow:0 0 6px rgba(67,233,123,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.pane-hint { font-size:11px;color:#b0b8c4;margin-left:auto; white-space:nowrap; }
.editor-pane ::v-deep .el-upload { width:100%; }
::v-deep .el-upload-dragger { max-width:100%; width:100%; box-sizing:border-box;  display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:170px; }
.wt-preview { background:#fff;border:1px solid #e4e7ed;border-radius:8px;padding:16px;max-height:500px;overflow-y:auto; }



@media (max-width: 640px) {
  .editor-pane { padding: 12px 14px; }
  .pane-hint { display: none; }
  .editor-pane ::v-deep .el-upload-dragger { min-height: 140px; padding: 20px 12px; }
  .editor-pane ::v-deep .el-upload__text { font-size: 12px; }
}

</style>
